// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__l1dB0","icon1":"Footer_icon1__p33Nt","icon2":"Footer_icon2__2T7OZ","icon3":"Footer_icon3__3rMkW"};